/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Envelope = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M23 9.30283V20H1V10.186L2.201 10.1858L2.5 10.4348V18.5H21.5V10.5468L23 9.30283ZM23 4V7.35238L22.219 7.999L21.5 8.59883L12 16.4743L1 7.35238V4H23ZM21.5 5.5H2.5V6.648L12 14.525L21.5 6.647V5.5Z"
                        fill={color}
                    />
                </svg>
        );
    };
